module.exports = __webpack_public_path__ + "static/media/feature-roles.b7d19830.png";